import React from 'react';
import { useTranslationAPI } from '../modules/translations/hooks';

export default (WrappedComponent) => {
	return function (props) {
		const { translate } = useTranslationAPI();
		return (
			<WrappedComponent
				{...props}
				translate={translate}
			/>
		);
	};
};
